type Props = {
  current: number
  total: number
};

export const StepDots = ({ current, total }: Props) => {
  return (
    <div
      role="presentation"
      aria-label={`Étape ${current} sur ${total}`}
      className="flex items-center justify-center gap-2"
    >
      {Array.from({ length: total }, (_, index) => {
        const step = index + 1;
        const isActive = step === current;
        return (
          <span
            key={step}
            className={`h-1.5 rounded-full transition-all duration-200 ${
              isActive
                ? "w-6 bg-gray-900 dark:bg-white"
                : "w-1.5 bg-gray-300 dark:bg-gray-600"
            }`}
          />
        );
      })}
    </div>
  );
};

StepDots.displayName = "StepDots";
